mutation UpdatePracticeTracking($enabled: Boolean!) {
  updatePracticeTracking(enabled: $enabled) {
    ok
    errors
  }
}
